import React, { PureComponent } from 'react';
import { Icon } from "semantic-ui-react";
import styles from './Input.module.css';

class Input extends PureComponent {
  render() {
    const { name, value, placeholder, onChange, type = "text", disabled, icon } = this.props;

    return (
      <div className={styles.inputContainer}>
        {icon && (
          <div className={styles.iconWrapper}>
            <Icon name={icon} />
          </div>
        )}
        <input
          disabled={disabled}
          className={`${styles.input} ${icon ? styles.hasIcon : ""}`}
          placeholder={placeholder}
          name={name}
          type={type}
          value={value}
          onChange={onChange}
        />
      </div>
    );
  }
}

export default Input;
